import { render } from "./OptionsLastVisit.vue?vue&type=template&id=3fd99cde"
import script from "./OptionsLastVisit.vue?vue&type=script&lang=js"
export * from "./OptionsLastVisit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__